"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _modalActions = require("../../redux/actions/modalActions");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./FuturesTransferButton.css");
var _marginSelectors = require("../../redux/margin/selectors/marginSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var createCls = (0, _cssClassesHelper.getBEMClasses)('futures-transfer-button');
var FuturesTransferButton = function FuturesTransferButton(_ref) {
  var onClick = _ref.onClick;
  var _useTranslation = (0, _reactI18next.useTranslation)('futures'),
    t = _useTranslation.t;
  var accounts = (0, _reactRedux.useSelector)(_marginSelectors.accountsSelector);
  if (accounts.length === 1) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls()
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "button",
    onClick: onClick,
    isDisabled: true
  }, /*#__PURE__*/_react["default"].createElement("span", null, t('Transfer Assets'))));
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    // productId is intentionally set to undefined
    onClick: function onClick() {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.MARGIN_TRANSFER_ASSETS, {
        productId: undefined
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(FuturesTransferButton);